import { render, staticRenderFns } from "./playlistSeriesItem.vue?vue&type=template&id=3bc4472b&"
import script from "./playlistSeriesItem.vue?vue&type=script&lang=js&"
export * from "./playlistSeriesItem.vue?vue&type=script&lang=js&"
import style0 from "./playlistSeriesItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "playlistSeriesItem.vue"
export default component.exports